import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

const routes: RouteConfig[] = [
  {
    path: '/',
    exact: true,
    component: loadable(() => import('../pages/home')),
  },
  {
    path: '/h5',
    exact: true,
    component: loadable(() => import('../pages/home')),
  },
  {
    path: '/role',
    exact: true,
    component: loadable(() => import('../pages/role')),
  },
  {
    path: '/chat',
    exact: true,
    component: loadable(() => import('../pages/chat')),
  },
  {
    path: '/event',
    exact: true,
    component: loadable(() => import('../pages/story')),
  },
  {
    path: '/login',
    exact: true,
    component: loadable(() => import('../pages/login')),
  },
  {
    path: '/userAgreement',
    exact: true,
    component: loadable(() => import('../pages/file/userAgreement')),
  },
  {
    path: '/privacyPolicy',
    exact: true,
    component: loadable(() => import('../pages/file/privacyPolicy')),
  },
  {
    path: '/card',
    exact: true,
    component: loadable(() => import('../pages/card')),
  },
  {
    path: '/editUserInfo',
    exact: true,
    component: loadable(() => import('../pages/editUserInfo')),
  },
  {
    path: '/relationship',
    exact: true,
    component: loadable(() => import('../pages/relationship')),
  },
  {
    path: '/memorylist',
    exact: true,
    component: loadable(() => import('../pages/memory')),
  },
  {
    path: '/help/userService',
    exact: true,
    component: loadable(() => import('../pages/help/userService')),
  },
  {
    path: '/help/threePartySDK',
    exact: true,
    component: loadable(() => import('../pages/help/threePartySDK')),
  },
  {
    path: '/help/appPermission',
    exact: true,
    component: loadable(() => import('../pages/help/appPermission')),
  },
  {
    path: '/help/privacyPolicy',
    exact: true,
    component: loadable(() => import('../pages/help/privacyPolicy')),
  },
  {
    path: '/help/refundAgreement',
    exact: true,
    component: loadable(() => import('../pages/help/refundAgreement')),
  },
  {
    path: '/help/aboutUs',
    exact: true,
    component: loadable(() => import('../pages/help/aboutUs')),
  },
  {
    path: '/help/personalInfo',
    exact: true,
    component: loadable(() => import('../pages/help/personalInfo')),
  },
  {
    path: '/help/communityConvention',
    exact: true,
    component: loadable(() => import('../pages/help/communityConvention')),
  },
  {
    path: '/bridgehome',
    exact: true,
    component: loadable(() => import('../pages/bridgeHome')),
  },
  {
    path: '/metrics',
    exact: true,
    component: loadable(() => import('../pages/notFound')),
  },
  {
    path: '/affinity',
    exact: true,
    component: loadable(() => import('../pages/affinity')),
  },
  {
    path: '/favorabilityRule',
    exact: true,
    component: loadable(() => import('../pages/favorabilityRule')),
  },
  {
    path: '/bondLevel',
    exact: true,
    component: loadable(() => import('../pages/bondLevel')),
  },
  {
    path: '/candyRecharge',
    exact: true,
    component: loadable(() => import('../pages/candyRecharge')),
  },
  {
    path: '/jellyOrders',
    exact: true,
    component: loadable(() => import('../pages/jellyOrders')),
  },
  {
    path: '/feedback',
    exact: true,
    component: loadable(
      () => import('../pages/home/components/JoinUs/CodeImg')
    ),
  },
  {
    path: '/algorithm',
    exact: true,
    component: loadable(() => import('../pages/help/algorithm')),
  },
  {
    path: '/inviteFriends',
    exact: true,
    component: loadable(() => import('../pages/inviteFriends')),
  },
  {
    path: '/h5/sharedPage',
    exact: true,
    component: loadable(() => import('../pages/sharedPage')),
  },
  {
    path: '/writingGuidance',
    exact: true,
    component: loadable(() => import('../pages/writingGuidance')),
  },
  {
    path: '/reviewFailReason',
    exact: true,
    component: loadable(() => import('../pages/reviewFailReason')),
  },
  {
    path: '/creativeRules',
    exact: true,
    component: loadable(() => import('../pages/creativeRules')),
  },
  {
    path: '/FAQPage',
    exact: true,
    component: loadable(() => import('../pages/FAQPage')),
  },
  {
    path: '/FAQPageNew',
    exact: true,
    component: loadable(() => import('../pages/FAQPageNew')),
  },
  {
    path: '/startPinch',
    exact: true,
    component: loadable(() => import('../pages/activity/startPinch')),
  },
  {
    path: '/buildActivity',
    exact: true,
    component: loadable(() => import('../pages/activity/buildActivity')),
  },
  {
    path: '/gardenPartyActivity',
    exact: true,
    component: loadable(() => import('../pages/activity/GardenParty')),
  },
  {
    path: '/creativeCollection',
    exact: true,
    component: loadable(() => import('../pages/activity/creativeCollection')),
  },
  {
    path: '/recommendDokimoActivity',
    exact: true,
    component: loadable(
      () => import('../pages/activity/recommendDokimoActivity')
    ),
  },
  {
    path: '/creatorAgreement',
    exact: true,
    component: loadable(() => import('../pages/creatorAgreement')),
  },
  {
    path: '/realNameService',
    exact: true,
    component: loadable(() => import('../pages/realNameService')),
  },
  {
    path: '/rankRules',
    exact: true,
    component: loadable(() => import('../pages/rankRules')),
  },
  {
    path: '/groupRules',
    exact: true,
    component: loadable(() => import('../pages/groupRules')),
  },
  {
    path: '/admissionNotice',
    exact: true,
    component: loadable(() => import('../pages/activity/admissionNotice')),
  },
  {
    path: '/analysisFortune',
    exact: true,
    component: loadable(() => import('../pages/activity/analysisFortune')),
  },
  {
    path: '/questionnaire',
    exact: true,
    component: loadable(() => import('../pages/questionnaire')),
  },
  {
    path: '/xinyoulingxi',
    exact: true,
    component: loadable(() => import('../pages/activity/xinyoulingxi')),
  },
  {
    path: '/prohibitRegistration',
    exact: true,
    component: loadable(() => import('../pages/prohibitRegistration')),
  },
]

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default (store) => routes
